import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import "./model.css";
import "./addticket.css";

export default function ImageModal(props) {
  const { show, handleClose, base64Content } = props;

  return (
    <>
      {/* <Button variant="primary" onClick={handleShow}>
        Launch modal
    </Button> */}

      <Modal show={show} onHide={handleClose} dialogClassName="custom-modal">
        <Modal.Header closeButton>
          <Modal.Title>Create Issue</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Your modal body content here */}
          <div class="modal-body">
            <img
              style={{ maxWidth: "100%", height: "auto" }}
              src={`data:image/jpeg;base64,${base64Content}`}
              className="card-img-top"
              alt={`Attachment`}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
